export const AUTH_REQUEST = 'AUTH_REQUEST';
export const AUTH_REQUESTEXTRA = 'AUTH_REQUESTEXTRA';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_SUCCESSEXTRA = 'AUTH_SUCCESSEXTRA';
export const AUTH_ERROR = 'AUTH_ERROR';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const SET_MODULE = 'SET_MODULE';